export default __webpack_public_path__ + "static/media/news60.b7fda936.jpg";